import store from '@/store/index';
import { mapActions } from 'vuex';
import { MODALS } from '@/components/app/app-modals/app-modals';
import { STATIC_PAGES } from '@/constants';
import cmsContentMixin from '@/mixins/cmsContent';

let toRoute = '';
let restore = true;

export default {
  mixins: [
    cmsContentMixin,
  ],
  metaInfo() {
    return {
      title: 'Privacy Policy',
    };
  },
  data() {
    return {
      content: '',
    };
  },
  methods: {
    ...mapActions('browse', ['getStaticPageFull']),
  },
  created() {
    this.getStaticPageFull(STATIC_PAGES.PRIVACY)
      .then((data) => {
        this.installDynamicControls({ data });
      });
  },
  beforeDestroy() {
    // firest after router loop
    if (restore) {
      store.dispatch('popup/restorePopup', toRoute);
    }
  },
  beforeRouteEnter(to, from, next) {
    const popup = to.params.noPopup ? null : MODALS.ACCOUNT_VERIFY;
    store.dispatch('popup/rememberPopup', {
      route: from.name,
      popup,
    });
    next();
  },
  beforeRouteLeave(to, from, next) {
    // fires before router loop closes popup
    restore = to.name !== 'terms-and-conditions';
    toRoute = to.name;
    next();
  },
};



// WEBPACK FOOTER //
// ./src/components/pages/page-privacy-policy/page-privacy-policy.js